module.exports = __webpack_public_path__ + "img/identify_edit1.72092ad9.png";